/**
 * Admin Dashboard - Main Layout
 * Uses modular components from ./admin/
 */
import { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { checkAuth } from "@/utils/auth";

// Admin Components
import Sidebar from "./admin/Sidebar";
import DashboardOverview from "./admin/DashboardOverview";
import QuotesList from "./admin/QuotesList";
import LeadsManagement from "./admin/LeadsManagement";
import CreditsManagement from "./admin/CreditsManagement";
import CampaignsManagement from "./admin/CampaignsManagement";
import PricingConfig from "./admin/PricingConfig";
import FranchisesManagement from "./admin/FranchisesManagement";
import AnalyticsDashboard from "./admin/AnalyticsDashboard";
import PromoCodesManagement from "./admin/PromoCodesManagement";

// Admin styles are in App.css

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const verifyAuth = async () => {
      const { authenticated } = await checkAuth();
      if (!authenticated) {
        navigate("/admin/login");
      } else {
        setIsAuthenticated(true);
      }
    };
    verifyAuth();
  }, [navigate]);

  // Show nothing while checking auth
  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="admin-dashboard">
      <Toaster position="top-right" richColors />
      
      <Sidebar />

      <main className="flex-1 p-8">
        <Routes>
          <Route path="/dashboard" element={<DashboardOverview />} />
          <Route path="/analytics" element={<AnalyticsDashboard />} />
          <Route path="/franchises" element={<FranchisesManagement />} />
          <Route path="/quotes" element={<QuotesList />} />
          <Route path="/leads" element={<LeadsManagement />} />
          <Route path="/credits" element={<CreditsManagement />} />
          <Route path="/promo-codes" element={<PromoCodesManagement />} />
          <Route path="/campaigns" element={<CampaignsManagement />} />
          <Route path="/pricing" element={<PricingConfig />} />
          <Route path="*" element={<DashboardOverview />} />
        </Routes>
      </main>
    </div>
  );
}
